<template>
  <div class="c2">
    <div class="c2-content">
      <div
        class="text-area"
        ref="content"
        @mouseenter="mouseenterEvent()"
        @mouseleave="mouseleaveEvent()"
      >
        <div class="list-content" ref="scroll1">
          <div class="list-item" v-for="(item, index) in valueMap" :key="index">
            <img
              src="@/assets/temimg13/tem13_icon_disc.png"
              alt=""
              class="disc_icon"
            />
            <div class="text_box text">
              <p>{{ item.name }}</p>
              <span>
                {{ defaultdata[0][item.key] }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as methods from "./method.js";
export default {
  name: "template.scope102",
  props: {
    vdata: {
      type: Array,
      default: () => [],
    },
    jsondata: {
      type: [Array, String],
      default: () => [],
    },
    valuemap: {
      type: [Array, String],
      default: () => [],
    },
    scopedata: {
      type: Object,
      default: () => { },
    },
  },
  data() {
    return {
      isList: true,
      textnum: 127,
      timer: null,
      defaultdata: [
        {
          value1: "暂无",
          value2: "G8公安部门",
          value3: "A5.1.5其他治安案",
          value4: "湖北-武汉市-",
          value5: "暂无",
          value6: "2025-03-20 12:23:34",
        },
      ],
      valueMap: [
        { name: "舆情主体：", key: "value1" },
        { name: "主体性质：", key: "value2" },
        { name: "舆情类型：", key: "value3" },
        { name: "事发地点：", key: "value4" },
        { name: "事件处置：", key: "value5" },
        { name: "更新时间：", key: "value6" },
      ],
      exceldata: [],
      apiconfig: {},
      isApi: false,
      scope: {},
      iscontact: false,
    };
  },
  watch: {
    vdata(n) {
      if (n && n.length) {
        const box = this.$refs.content;
        box.scrollTop = 0;
        this.defaultdata = n;
      }
    },
    jsondata(n) {
      this.exceldata = n;
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.rollUp(150);
    });
    if (this.valuemap && this.valuemap.length) {
      this.valueMap = this.valuemap;
    }
    if (this.vdata && this.vdata.length) {
      this.defaultdata = this.vdata;
    }
    this.setData()
  },
  methods: {
    ...methods,
    rollUp(t) {
      const ulf1 = this.$refs.scroll1;
      const box = this.$refs.content;
      if (ulf1.offsetHeight > 120) {
        box.scrollTop = 0;
        this.timer = setInterval(this.rollStart, t);
      } else if (ulf1.offsetHeight == 0) {
        setTimeout(() => {
          this.rollUp(150);
        }, 200);
      }
    },
    rollStart() {
      const ulf1 = this.$refs.scroll1;
      const box = this.$refs.content;
      if (box.scrollTop >= ulf1.scrollHeight) {
        box.scrollTop = 0;
      } else {
        box.scrollTop += 2;
      }
    },
    mouseenterEvent() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    mouseleaveEvent(t) {
      if (!this.timer) {
        this.timer = setInterval(this.rollStart, 150);
      }
    },
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
  },
};
</script>

<style scoped lang="scss">
.c2 {
  width: 435px;
  height: 240px;
  margin: 0px auto 0 auto;
  position: relative;
  overflow: hidden;
  pointer-events: auto;
  cursor: pointer;
  padding: 10px 0;
  .text {
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 16px;
    color: #b3d8f6;
    // width: 103px;
    // max-width: 103px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    text-align: center;

    img {
      width: 23px;
      height: 19px;
    }
  }

  .list-item {
    height: 38px;
    display: flex;
    align-items: center;
    // padding: 12px 0;
    box-sizing: border-box;
    // min-height: 18px;
    background: rgba(59, 120, 177, 0.05);
    .text_box {
      display: flex;

      span {
        color: #009aff;
      }
    }

    .text {
      color: #b3d8f6;
    }

    &:nth-child(2n + 1) {
      background: rgba(59, 120, 177, 0.16);
    }
  }

  .disc_icon {
    width: 25px;
    height: 25px;
    transform: rotate(45deg);
    margin: 0 8px 0 12px;
  }
  .text-area {
    pointer-events: auto;
    max-height: 240px;
    overflow-y: auto;

    &::-webkit-scrollbar {
      width: 0;
    }
  }
  .c2-content {
    height: 100%;
  }
}
</style>
